module.exports = __webpack_public_path__ + "static/media/styles.efe433e1.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/gdc-components-atoms-label/styles.scss
// module id = 484
// module chunks = 0